<template>
  <div v-if="drawComponent && !disableCalendar"
       class="date-field"
  >
    <label class="date-field__label"
           :class="{
             'date-field__label--unfocus': !value,
             'date-field__label--disabled': disabled
           }"
    >
      {{ label }}
    </label>

    <div class="date-field__field"
         :class="{ 'date-field__field--disabled': disabled }"
    >
      <flat-pickr :id="id"
                  class="date-field__input"
                  :config="config"
                  :value="value"
                  :disabled="disabled"
                  ref="calendar"
                  @input.native="dateFieldUpdated"
                  @onOpen="setConfig"
                  @change="changeValue"
      />
      <span v-if="clearable && value && value.length"
            class="date-field__clear"
            @click="reset">
        <md-icon class="clear-icon">clear</md-icon>
      </span>
    </div>
    <div class="date-field__err-mes" v-if="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

</template>

<script>
  import FlatPickr from 'vue-flatpickr-component'
  import moment from 'moment'
  import field from './field.mixin'
  import { commonEvents } from '@js/events/common_events'

  export default {
    name: 'date-field-flatpickr',

    components: {
      FlatPickr
    },

    mixins: [field],

    props: {
      enableTime: { type: Boolean, default: false },
      disableCalendar: { type: Boolean, default: false },
      disableBefore: { type: String, default: '' },
      disableAfter: { type: String, default: '' },
      label: { type: String, default: '' },
      clearable: { type: Boolean, default: false }
    },

    data () {
      return {
        date: '',
        drawComponent: true,
        disableCalendar: false
      }
    },
    computed: {
      config () {
        let vm = this
        return {
          altInput: true,
          altFormat: this.enableTime ? 'F j, Y H:i' : 'F j, Y',
          disableMobile: true,
          enableTime: this.enableTime,
          disableCalendar: this.disableCalendar,
          time_24hr: true,
          onOpen (selectedDates, dateStr, instance) {
            instance.set('disable', [
              (date) => {
                if (!vm.disableBefore) return false
                const stamp = moment(vm.disableBefore)
                return moment(date).isBefore(stamp)
              },
              (date) => {
                if (!vm.disableAfter) return false
                const stamp = moment(vm.disableAfter)
                return moment(date).isAfter(stamp)
              }
            ])
          }
        }
      }
    },
    methods: {
      dateFieldUpdated (event) {
        this.onInput(event.target.value)
        this.$emit(commonEvents.dateChange)
      },
      reset () {
        /* TODO: the validator must be disabled before, bk we got error (not exception - this is a todo2) */
        let vm = this
        vm.drawComponent = false
        this.$nextTick(() => {
          vm.drawComponent = true
          vm.onInput('')
        })
        vm.$emit(commonEvents.clearEvent)
      }
    }
  }
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';
  .date-field__clear {
    position: absolute;
    top: 0;
    right: 5px;
  }
  .date-field {
    position: relative;
    width: 100%;
    max-width: 300px;
    margin-top: 16px;
    flex: 1;

    &__field {
      &--disabled {
        pointer-events: none;

        .date-field__input {
          border-bottom: 1px dashed;
          cursor: default;
          filter: grayscale(100%);
          -webkit-text-fill-color: rgba($grey, .5);
          color: rgba($grey, .5);
        }
      }
    }

    &__input {
      height: 100%;
      padding: 6px 16px;
      color: $col-text;
      font-size: 16px;
      background-color: transparent;
      border: none;
    }

    &__label,
    &__label--unfocus {
      position: absolute;
      top: -14px !important;
      left: 8px !important;
      max-width: 100%;
      padding: 4px;
      font-size: 14px;
      background-color: $default-white;
      color: $col-text;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      opacity: 1;

      &--disabled {
        color: rgba(0, 0, 0, 0.42);
      }

     /* &--unfocus {
        top: 14px;
        left: 16px;
        font-size: 16px;
      }*/
    }

    &__field {
      width: 300px;
      height: 48px;
      @include border(1px, 8px, $col-md-accent)
    }

    &__err-mes {
      color: $col-md-accent;
      margin-top: 4px;
      font-size: 12px;
      line-height: 1.25;
    }

    &__clear {
      margin: 0;
      padding: 0;

      & .clear-icon-size {
        width: 16px;
        min-width: 16px;
        height: 16px;
        font-size: 16px!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/common/fields/DateFieldFlatpickr.vue